import React, { Fragment } from 'react'
import { string, bool } from 'prop-types'

function KeywordLetter({ char, isBolded = false }) {
  return isBolded ? <Fragment>{char}</Fragment> : <b>{char}</b>
}

KeywordLetter.propTypes = {
  char: string.isRequired,
  isBolded: bool,
}

export default KeywordLetter
